// validationUtils.ts
import i18n from 'modules/core/lib/i18n'

import { CustomTimeRangesFormData } from 'modules/attendance/lib/forms/utils/CustomTimeRangesFormData'

interface FormErrors {
  attendance_custom_time_range_category_id: string
  day: string
  end_time: string
  start_time: string
}

const validateCategory = (formValues: CustomTimeRangesFormData, errors: FormErrors) => {
  if (!formValues.attendance_custom_time_range_category_id) {
    errors.attendance_custom_time_range_category_id = i18n.t(
      'time_tracking.settings.time_blocks.categories.modals.errors.missing_category'
    )
  }
}

const validateDay = (formValues: CustomTimeRangesFormData, errors: FormErrors) => {
  if (formValues.day.length === 0) {
    errors.day = i18n.t('time_tracking.settings.time_blocks.categories.modals.errors.missing_day')
  }
}

const validateEndTime = (
  formValues: CustomTimeRangesFormData,
  openCustomOptions: boolean,
  errors: FormErrors
) => {
  if (openCustomOptions && !formValues.end_time) {
    errors.end_time = i18n.t('time_tracking.settings.time_blocks.categories.modals.errors.end_time')
  }
}

const validateStartTime = (
  formValues: CustomTimeRangesFormData,
  openCustomOptions: boolean,
  errors: FormErrors
) => {
  if (openCustomOptions && !formValues.start_time) {
    errors.start_time = i18n.t(
      'time_tracking.settings.time_blocks.categories.modals.errors.start_time'
    )
  }
}

export const validateForm = (formValues: CustomTimeRangesFormData, openCustomOptions: boolean) => {
  const errors: FormErrors = {
    attendance_custom_time_range_category_id: '',
    day: '',
    end_time: '',
    start_time: '',
  }

  validateCategory(formValues, errors)
  validateDay(formValues, errors)
  validateEndTime(formValues, openCustomOptions, errors)
  validateStartTime(formValues, openCustomOptions, errors)

  return errors
}
